<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <template v-if="circle">
      <path d="M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z" :fill="circleColor" />
      <path d="M10,17.87l-6-6L5.87,10,10,14.13l7.47-7.46,1.86,1.86Z" :fill="checkColor" />
    </template>
    <template v-else>
      <path d="M9,16.2,4.8,12,3.4,13.4,9,19,21,7,19.6,5.6Z" :fill="checkColor" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'CheckIcon',
  props: {
    /* 丸い枠を表示します */
    circle: Boolean,
    /* fill */
    checkColor: { type: String, default: '#fff' },
    /* 丸い枠の色 */
    circleColor: { type: String },
  },
}
</script>
